<template>
  <div>
    <!-- md screens sidebar -->
    <b-sidebar
      class="sidebar-container"
      id="sidebar-1"
      bg-variant="dark"
      no-header
    >
      <aside class="sidebar-tabs d-flex flex-column">
        <ul class="sidebar-tabs-list-container position-relative">
          <div class="d-flex align-items-center" v-if="!isOwnerUser">
            <span
              v-if="tasksActive || hover.tasks"
              class="sidebar-icons sidebar-icon-mask sidebar-icon-tasks-active"
              aria-hidden="true"
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/tasks_inactive.svg"
              alt
            />
            <li
              :class="[tasksActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'TaskDashboard' })"
              @mouseover="mouseOver('tasks')"
              @mouseleave="mouseLeave('tasks')"
            >
              Tasks
            </li>
          </div>

          <div
            class="d-flex align-items-center"
            v-if="shouldShowMenuItemTo(userRoles.ADMIN)"
          >
            <img
              v-if="companiesActive || hover.companies"
              class="sidebar-icons"
              src="@/assets/icons/company_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/company_inactive.svg"
              alt
            />
            <li
              :class="[companiesActive ? 'list-item-active' : null]"
              @click="navigateToCompanies"
              @mouseover="mouseOver('companies')"
              @mouseleave="mouseLeave('companies')"
            >
              Company
            </li>
          </div>

          <div class="d-flex align-items-center">
            <img
              v-if="customersActive || hover.customers"
              class="sidebar-icons"
              src="@/assets/icons/customer_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/customer_inactive.svg"
              alt
            />
            <li
              :class="[customersActive ? 'list-item-active' : null]"
              @click="navigateToCustomers"
              @mouseover="mouseOver('customers')"
              @mouseleave="mouseLeave('customers')"
            >
              Customers
            </li>
          </div>
          <div class="d-flex align-items-center">
            <img
              v-if="assistantsActive || hover.assistants"
              class="sidebar-icons"
              src="@/assets/icons/pa_directory_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/pa_directory_inactive.svg"
              alt
            />

            <li
              :class="[assistantsActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'ViewPADirectory' })"
              @mouseover="mouseOver('assistants')"
              @mouseleave="mouseLeave('assistants')"
            >
              Team
            </li>
          </div>

          <div class="d-flex align-items-center">
            <img
              v-if="resourcesActive || hover.resources"
              class="sidebar-icons"
              src="@/assets/icons/resources_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/resources_inactive.svg"
              alt
            />

            <li
              :class="[resourcesActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'Resources' })"
              @mouseover="mouseOver('resources')"
              @mouseleave="mouseLeave('resources')"
            >
              Resources
            </li>
          </div>

          <div class="d-flex align-items-center">
            <img
              v-if="reportsActive || hover.reports"
              class="sidebar-icons"
              src="@/assets/icons/reports_sidebar.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/reports_sidebar_inactive.svg"
              alt
            />

            <li
              :class="[reportsActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'ReportsList' })"
              @mouseover="mouseOver('reports')"
              @mouseleave="mouseLeave('reports')"
            >
              Reports
            </li>
          </div>

          <!-- <div class="d-flex align-items-center" v-if="role === 'admin'">
            <img
              v-if="capacityActive || hover.capacity"
              class="sidebar-icons"
              src="@/assets/icons/reports_sidebar.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/reports_sidebar_inactive.svg"
              alt
            />

            <li
              :class="[capacityActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'Capacity' })" @mouseover="mouseOver('capacity')" @mouseleave="mouseLeave('capacity')"
            >
              Capacity
            </li>
          </div> -->
        </ul>
      </aside>
    </b-sidebar>
    <!-- End -->

    <!-- Toggleable sidebar -->
    <b-sidebar
      class="sidebar-container-responsive"
      id="sidebar-2"
      bg-variant="dark"
      backdrop
      no-header-close
    >
      <aside class="sidebar-tabs d-flex flex-column">
        <b-button
          v-b-toggle.sidebar-2
          class="d-flex position-absolute close-btn"
        >
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
        <div class="d-flex flex-column sidebar-user-details">
          <b-avatar
            v-if="navAvatar"
            size="6rem"
            class="sidebar-avatar mb-4"
            :src="navAvatar"
          ></b-avatar>
          <b-avatar
            v-else
            size="6rem"
            class="sidebar-avatar mb-4"
            style="background-color: #074f89; cursor: pointer"
            :text="userInitials"
          ></b-avatar>
          <h3 class="font-lg font-family-medium">
            {{ fullName }}
          </h3>
          <!-- <p class="secondary--text">30 hours/week</p> -->
        </div>
        <ul class="sidebar-tabs-list-container position-relative">
          <div class="d-flex align-items-center" v-if="!isOwnerUser">
            <span
              v-if="tasksActive || hover.tasks"
              class="sidebar-icons sidebar-icon-mask sidebar-icon-tasks-active"
              aria-hidden="true"
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/tasks_inactive.svg"
              alt
            />
            <li
              :class="[tasksActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'TaskDashboard' })"
              @mouseover="mouseOver('tasks')"
              @mouseleave="mouseLeave('tasks')"
            >
              Tasks
            </li>
          </div>

          <div
            class="d-flex align-items-center"
            v-if="shouldShowMenuItemTo(userRoles.ADMIN)"
          >
            <img
              v-if="companiesActive || hover.companiesActive"
              class="sidebar-icons"
              src="@/assets/icons/customer_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/customer_inactive.svg"
              alt
            />
            <li
              :class="[companiesActive ? 'list-item-active' : null]"
              @click="navigateToCompanies"
              @mouseover="mouseOver('companiesActive')"
              @mouseleave="mouseLeave('companiesActive')"
            >
              Companies
            </li>
          </div>

          <div class="d-flex align-items-center">
            <img
              v-if="customersActive || hover.customers"
              class="sidebar-icons"
              src="@/assets/icons/customer_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/customer_inactive.svg"
              alt
            />
            <li
              :class="[customersActive ? 'list-item-active' : null]"
              @click="navigateToCustomers"
              @mouseover="mouseOver('customers')"
              @mouseleave="mouseLeave('customers')"
            >
              Customers
            </li>
          </div>
          <div class="d-flex align-items-center">
            <img
              v-if="assistantsActive || hover.assistants"
              class="sidebar-icons"
              src="@/assets/icons/pa_directory_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/pa_directory_inactive.svg"
              alt
            />

            <li
              :class="[assistantsActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'ViewPADirectory' })"
              @mouseover="mouseOver('assistants')"
              @mouseleave="mouseLeave('assistants')"
            >
              Team
            </li>
          </div>
          <div class="d-flex align-items-center">
            <img
              v-if="resourcesActive || hover.resources"
              class="sidebar-icons"
              src="@/assets/icons/resources_active.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/resources_inactive.svg"
              alt
            />

            <li
              :class="[resourcesActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'Resources' })"
              @mouseover="mouseOver('resources')"
              @mouseleave="mouseLeave('resources')"
            >
              Resources
            </li>
          </div>

          <div class="d-flex align-items-center">
            <img
              class="sidebar-icons"
              v-if="reportsActive || hover.reports"
              src="@/assets/icons/reports_sidebar.svg"
              alt
            />
            <img
              v-else
              class="sidebar-icons"
              src="@/assets/icons/reports_sidebar_inactive.svg"
              alt
            />

            <li
              :class="[reportsActive ? 'list-item-active' : null]"
              @click="$router.push({ name: 'ReportsList' })"
              @mouseover="mouseOver('reports')"
              @mouseleave="mouseLeave('reports')"
            >
              Reports
            </li>
          </div>

          <div
            v-if="!isOwnerUser"
            @click="openHeadroomSlack"
            class="d-flex mt-5 d-lg-none align-items-center cursor-pointer"
          >
            <b-icon-chat-left-fill scale="1.5"></b-icon-chat-left-fill>

            <li>Messages</li>
          </div>
          <div v-if="!isOwnerUser" class="d-flex d-lg-none align-items-center">
            <b-icon-bell-fill scale="1.5"></b-icon-bell-fill>
            <li>Notifications</li>
          </div>
        </ul>
      </aside>
      <b-button
        @click="logoutUser"
        class="btn-danger btn-pill logout-btn py-3 mt-2 ml-5 w-75"
      >
        Logout
        <!-- <b-spinner variant="light" label="Spinning"></b-spinner> -->
      </b-button>
    </b-sidebar>
    <!-- End toggleable sidebar -->
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { USER_ROLES } from "@/utils/constants/index";

export default {
  name: "Sidebar",
  data() {
    return {
      userRoles:USER_ROLES,
      companiesActive: false,
      customersActive: false,
      assistantsActive: false,
      tasksActive: false,
      resourcesActive: false,
      reportsActive: false,
      capacityActive: false,
      userInitials: "",
      hover: {
        customers: false,
        assistants: false,
        tasks: false,
        resources: false,
        reports: false,
        capacity: false
      }
    };
  },
  created() {
    if (this.fullName.length > 0) {
      this.userInitials = this.fullName.match(/\b(\w)/g).join("");
    }
    let {
      companies,
      customers,
      assistants,
      tasks,
      resources,
      reports,
      capacity
    } = this.$route.meta;
    this.companiesActive = !!companies;
    this.customersActive = !!customers;
    this.assistantsActive = !!assistants;
    this.tasksActive = !!tasks;
    this.resourcesActive = !!resources;
    this.reportsActive = !!reports;
    this.capacityActive = !!capacity;
  },
  computed: {
    ...mapState("authModule", ["role", "navAvatar", "fullName"]),
    isOwnerUser() {
      return this.role === USER_ROLES.OWNER;
    }
  },
  watch: {
    fullName() {
      if (this.fullName) {
        this.userInitials = this.fullName.match(/\b(\w)/g).join("");
      }
    },
    $route(to) {
      this.companiesActive = !!to.meta.companies;
      this.customersActive = !!to.meta.customers;
      this.assistantsActive = !!to.meta.assistants;
      this.tasksActive = !!to.meta.tasks;
      this.resourcesActive = !!to.meta.resources;
      this.reportsActive = !!to.meta.reports;
      this.capacityActive = !!to.meta.capacity;
    }
  },
  methods: {
    /**
     * Show or hide menu item based on user role.
     * @param {string} role User role to whom menu item to be shown.
     * @returns {boolean}
     */
    shouldShowMenuItemTo(role = "all") {
      let userRole = this.role;
      return role === "all" || userRole === role;
    },
    openHeadroomSlack() {
      window.open("https://headroomassistance.slack.com", "_blank");
    },
    mouseOver(item) {
      this.hover[item] = true;
    },
    mouseLeave(item) {
      this.hover[item] = false;
    },
    logoutUser() {
      this.actionLogoutUser()
        .then(() => {
          this.$router.push("/login");
        })
        .catch(err => {
          console.log(err);
        });
    },
    navigateToCompanies() {
      if (this.role === "admin") {
        this.$router.push({
          name: "CompanyListAdmin",
          query: {
            tab: 0
          }
        });
      }
    },

    navigateToCustomers() {
      if (this.role === "assistant" || this.isOwnerUser) {
        this.$router.push({ name: "DedicatedCustomers" });
      } else if (this.role === "admin") {
        this.$router.push({
          name: "CustomersListAdmin",
          query: {
            tab: 0
          }
        });
      }
    },
    ...mapActions("authModule", ["actionLogoutUser"])
  }
};
</script>

<style scoped lang="scss">
@import "@/scss/variables/colors.scss";

.b-sidebar > .b-sidebar-body {
  flex-grow: 1;
  height: 100%;
  overflow-y: auto;
  width: 27.1rem;
}
.sidebar-user-details {
  padding: 1rem 1rem 0 3.5rem;
  h3 {
    color: white;
  }
}

.sidebar-icons {
  width: 1.6rem;
  height: 1.6rem;
}

.sidebar-icon-mask.sidebar-icon-tasks-active {
  display: inline-block;
  flex-shrink: 0;
  background-color: var(--td-tab-active, #8f00ff);
  -webkit-mask-image: url("~@/assets/icons/tasks_active.svg");
  mask-image: url("~@/assets/icons/tasks_active.svg");
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-size: contain;
  mask-size: contain;
}
button.btn.close-btn {
  right: -10%;
  background: none;
}
.close-icon {
  width: 3.2rem;
  height: 3.2rem;
}
@media screen and (max-width: 991px) {
  .b-sidebar#sidebar-1,
  .b-sidebar.sidebar-container {
    // Overriding inline styles
    display: none !important;
  }
}
@media screen and (max-width: 359px) {
   .b-sidebar.sidebar-container-responsive#sidebar-2 {
    display: flex;
    width: 21.7rem;
    top: 0;
  }
}
@media screen and (max-width: 320px ) {
  .b-sidebar.sidebar-container-responsive#sidebar-2 {
    display: flex;
    width: 85%;
  }
}
svg.bi-chat-left-fill.b-icon.bi,
svg.bi-bell-fill.b-icon.bi {
  color: #ffffff;
}
</style>
